import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ChartContainer, ChartTooltip, ChartTooltipContent } from '@/components/ui/chart';
import { BoxIcon } from 'lucide-react';
import { Bar, BarChart, CartesianGrid, XAxis, YAxis } from 'recharts';

interface TopBuildItem {
	buildId: string;
	appName: string;
	profileNickname?: string;
	clientsCount: number;
}

interface TopBuildsChartProps {
	data: TopBuildItem[];
	title?: string;
	showWorker?: boolean;
}

const chartConfig = {
	clientsCount: { label: 'Клиенты', color: 'var(--chart-1)' },
};

export default function TopBuildsChart({ data, title = 'Топ билдов', showWorker = true }: TopBuildsChartProps) {
	const chartData = data.map(d => ({
		name: d.appName.length > 12 ? `${d.appName.slice(0, 12)}…` : d.appName,
		fullName: showWorker && d.profileNickname ? `${d.appName} (#${d.profileNickname})` : d.appName,
		clientsCount: d.clientsCount,
	}));

	return (
		<Card className='gap-0 py-0 shadow-sm overflow-hidden'>
			<CardHeader className='border-b px-4 py-3'>
				<div className='flex items-center gap-2'>
					<div className='rounded-lg bg-chart-1/15 p-1.5'>
						<BoxIcon className='text-chart-1' size={16} />
					</div>
					<CardTitle className='text-sm'>{title}</CardTitle>
				</div>
			</CardHeader>
			<CardContent className='px-2 py-3'>
				{chartData.length === 0 ? (
					<div className='h-[200px] flex items-center justify-center text-sm text-muted-foreground'>Нет данных</div>
				) : (
					<ChartContainer config={chartConfig} className='w-full' style={{ height: Math.max(200, chartData.length * 36) }}>
						<BarChart data={chartData} layout='vertical' margin={{ top: 0, right: 8, left: 0, bottom: 0 }}>
							<CartesianGrid strokeDasharray='3 3' horizontal={false} />
							<XAxis type='number' tickLine={false} axisLine={false} tick={{ fontSize: 10 }} allowDecimals={false} />
							<YAxis type='category' dataKey='name' tickLine={false} axisLine={false} tick={{ fontSize: 10 }} width={80} />
							<ChartTooltip
								content={
									<ChartTooltipContent
										labelFormatter={(_, payload) => String(payload?.[0]?.payload?.fullName ?? '')}
									/>
								}
							/>
							<Bar dataKey='clientsCount' fill='var(--chart-1)' radius={[0, 4, 4, 0]} />
						</BarChart>
					</ChartContainer>
				)}
			</CardContent>
		</Card>
	);
}
